module.exports = __webpack_public_path__ + "media/images/event-list-cba87cd2d835f28366c8b765384eca5e.png";